import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {RouterLink} from '@angular/router';
import {ANALYTICS_EVENTS, AnalyticsService} from '../services/analytics.service';

@Component({
    selector: 'app-licensing',
    templateUrl: './licensing.component.html',
    styleUrls: ['./licensing.component.css'],
    imports: [CommonModule, RouterLink]
})

export class LicensingComponent implements OnInit {

    closeResult: string = '';
    constructor(private modalService: NgbModal,
                private analyticsService: AnalyticsService ) { }

    ngOnInit(): void {
    }

    open(content:any) {
        this.analyticsService.track( ANALYTICS_EVENTS[ 'LICENSING' ] , "" );
        this.modalService.open(content, { scrollable: true, ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
            this.closeResult = 'Closed with: ${result}';
        }, (reason) => {
            this.closeResult = 'Dismissed ${this.getDismissReason(reason)}';
        });
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return 'with: ${reason}';
        }
    }
}
